export default class ApiKeyForm {
  constructor (data) {
    this.appName = data.appName;
    this.secret = data.secret;
  }
}
